import { useEffect, useState } from 'react'
import SideBar from '../../components/SideBar'
import NavBar from '../../components/NavBar'
import Footer from '../../components/Footer';
import { Button, Modal, Table } from 'antd';
import { EditOutlined, PlusOutlined } from '@ant-design/icons';
import axiosInstance from '../../variables/api/axiosInstance';
import { set } from 'react-hook-form';
import { use } from 'react';

const AllRoutes = () => {
  const [routes, setRoutes] = useState([]);
  const [openAddModal, setOpenAddModal] = useState(false);
  const [libelle, setLibelle] = useState("");
  const [chemin, setChemin] = useState("");
  const [component, setComponent] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const [route, setRoute] = useState({});

  const columns = [
    {
      title: "Libellé",
      dataIndex: "label",
      key: "label",
    },
    {
      title: "Chemin",
      dataIndex: "path",
      key: "path",
    },
    {
      title: "Component",
      dataIndex: "component",
      key: "component",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <div class="d-flex">
          <Button
            type="primary"
            icon={<EditOutlined />}
            style={{ marginBottom: 16 }}
            onClick={() => {
              setEditMode(true);
              setOpenAddModal(true);
              setRoute(record);
              setLibelle(record.label);
              setChemin(record.path);
              setComponent(record.component);
            }}
          >
          </Button>
        </div>
      ),
    },
  ];

  const handleSubmit = () => {
    setLoading(true);
    const rt = {
      label: libelle,
      path: chemin,
      component: component,
    };
    console.log(rt);
    if (editMode) {
      route.label = libelle;
      route.path = chemin;
      route.component = component;
      console.log(route);

      axiosInstance.put(`/api/route`, route).then((res) => {
        setOpenAddModal(false);
        setReload(true);
        setLoading(false);
        setLibelle("");
        setChemin("");
        setComponent("");
      }).catch((err) => {
        console.log(err);
        setLoading(false);
      });
    } else {
      axiosInstance.post(`/api/route`, rt).then((res) => {
        setOpenAddModal(false);
        setReload(true);
        setLoading(false);
        setLibelle("");
        setChemin("");
        setComponent("");
      }).catch((err) => {
        console.log(err);
        setLoading(false);
      });
    }

  };

  useEffect(() => {
    axiosInstance
      .get(`/api/route`)
      .then((res) => {
        console.log(res.data);
        setRoutes(res.data.content);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [reload]);

  return (
    <div class="layout-wrapper layout-content-navbar  ">
      <div class="layout-container">
        <SideBar currentMenu={"DROITS"} />

        {/* <!-- Layout container --> */}
        <div class="layout-page">
          <NavBar />

          {/* <!-- Content wrapper --> */}
          <div class="content-wrapper">
            {/* <!-- Content --> */}
            <div class="container-xxl flex-grow-1 container-p-y">
              <div class="card">
                <h5 class="card-header">
                  Les différentes routes de l'application
                </h5>
                <div className="col-4">
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    style={{ marginBottom: 16 }}
                    onClick={() => {
                      setEditMode(false);
                      setOpenAddModal(true);
                    }}
                  >
                    Créer une nouvelle route
                  </Button>
                </div>
                <div class="table-responsive text-nowrap">
                  <Table columns={columns} dataSource={routes} />
                </div>
              </div>
            </div>
            {/* <!-- / Content --> */}

            {/* <!-- Footer --> */}
            <Footer />
            {/* <!-- / Footer --> */}

            <div class="content-backdrop fade"></div>
          </div>
          {/* <!-- Content wrapper --> */}
        </div>
        {/* <!-- / Layout page --> */}
      </div>
      <Modal
        open={openAddModal}
        title={editMode ? "Modifier une route" : "Créer une nouvelle route"}
        onCancel={() => {
          setLibelle("");
          setChemin("");
          setComponent("");
          setOpenAddModal(false);
        }}
        okText={editMode ? "Modifier" : "Créer"}
        cancelText="Annuler"
        onOk={handleSubmit}
        loading={loading}
      >
        <div className="row">
          <div className="col-md-12 mb-3">
            <label className="form-label">Libellé</label>
            <input type="text" className="form-control" placeholder='Libellé' onChange={(e) => setLibelle(e.target.value)} value={libelle} />
          </div>
          <div className="col-md-12 mb-3">
            <label className="form-label">Chemin</label>
            <input type="text" className="form-control" placeholder='Chemin' onChange={(e) => setChemin(e.target.value)} value={chemin} />
          </div>
          <div className="col-md-12 mb-3">
            <label className="form-label">Component</label>
            <input type="text" className="form-control" placeholder='Component' onChange={(e) => setComponent(e.target.value)} value={component} />
          </div>
        </div>
      </Modal>

      {/* <!-- Overlay --> */}
      <div class="layout-overlay layout-menu-toggle"></div>

      {/* <!-- Drag Target Area To SlideIn Menu On Small Screens --> */}
      <div class="drag-target"></div>
    </div>
  )
}

export default AllRoutes
